import { render, staticRenderFns } from "./IconSample.vue?vue&type=template&id=30a9a38a&"
import script from "./IconSample.vue?vue&type=script&lang=js&"
export * from "./IconSample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports